import JSX from "../../../helpers/react.js";
import TextInput from "../../../models/elements/TextInput.js";
import RefObject = JSX.RefObject;
import {formatYoutubeLink} from "../../../helpers/functions.js";

interface Props {number: string, player: string, dubbing: string, iframe_url: string, onChange: (key: keyof Props, value: string)=>any, onDelete: ()=>any}
export function OneTrailerEdit(props:Props){
    const element: RefObject<HTMLElement> = {},
        linkRef: RefObject<HTMLInputElement> = {}
    return (
        <div style={{display: 'flex'}} ref={element}>
            <TextInput value={props.number}
                       name="Номер"
                       placeholder={"Номер"}
                       onChange={value =>props.onChange('number', value!)}
                       style={{minWidth: '10vw', maxWidth: '70px'}}/>
            <TextInput value={props.player}
                       name="Плеер"
                       placeholder="Плеер"
                       onChange={value=>props.onChange('player', value!)}
                       style={{minWidth: '20vw', maxWidth: '150px'}}
            />
            <TextInput value={props.dubbing}
                       name="Озвучка"
                       placeholder="Озвучка"
                       onChange={value=>props.onChange('dubbing', value!)}
                       style={{minWidth: '20vw', maxWidth: '150px'}}
            />
            <TextInput value={props.iframe_url}
                       ref={linkRef}
                       name="Ссылка"
                       placeholder="Ссылка"
                       onChange={function(this: HTMLInputElement, value){
                           let valueNew = formatYoutubeLink(value??"")?.src?? value;
                           if(valueNew && valueNew !== value) {
                               linkRef.value!.value = valueNew;
                               value = valueNew;
                               // this.value = valueNew;
                           }
                           props.onChange('iframe_url', value!)}
                       }/>
            <div className="delete-button" style={{minWidth: "50px", maxWidth: "50px"}} onClick={()=>props.onDelete.call(element.value!)}>
                <i className="far fa-trash"></i>
            </div>
        </div>
    )
}